// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qit8ctL5PoTnJFWiXp3B {
  border-radius: 0.375rem;
  border-width: 2px;
  --tw-border-opacity: 1;
  border-color: rgb(22 121 208 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(224 244 255 / var(--tw-bg-opacity, 1));
  padding: 1.25rem;
  font-family: Noto Sans;
}

._qDbpGmEToW6RwSmt2Zh {
  margin-bottom: 0.5rem;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
}

.qFmySP54VOtfZwF7hcvw {
  margin-bottom: 0.5rem;
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
}

.DlCfVbm11Uy_d0GuwdYA {
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
}

.ZZYvQ3qNFZ8pXzynxNMz {
  margin-bottom: 0px;
}

.T8O0SRaaXJvCpUfkqMhy {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  -moz-column-gap: 1.5rem;
       column-gap: 1.5rem;
  row-gap: 0.25rem;
  font-size: 16px;
  line-height: 24px;
}

.UcxNEx0wq5CELbxxmwqu {
  display: flex;
  gap: 0.25rem;
}

.e7sPgtSArdcSWbxe6CgJ {
  font-weight: 400;
}

.QXGHtLmEWNDb7rWXRMAu {
  font-weight: 600;
}

/* Customer Consent page */
.nQXDhC5wLyKGzK8ChiOa {
  padding: 1rem;
}
@media (min-width: 1024px) {

  .nQXDhC5wLyKGzK8ChiOa {
    padding: 1.25rem;
  }
}

.nQXDhC5wLyKGzK8ChiOa ._qDbpGmEToW6RwSmt2Zh {
  margin-bottom: 0.5rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5rem;
}

@media (min-width: 1024px) {

  .nQXDhC5wLyKGzK8ChiOa ._qDbpGmEToW6RwSmt2Zh {
    font-size: 24px;
    line-height: 2rem;
  }
}

.nQXDhC5wLyKGzK8ChiOa .qFmySP54VOtfZwF7hcvw {
  margin-bottom: 0.5rem;
  font-size: 1.5rem;
  font-weight: 600;
  line-height: 1.75rem;
}

@media (min-width: 1024px) {

  .nQXDhC5wLyKGzK8ChiOa .qFmySP54VOtfZwF7hcvw {
    font-size: 36px;
    line-height: 2rem;
  }
}

.nQXDhC5wLyKGzK8ChiOa .DlCfVbm11Uy_d0GuwdYA {
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5rem;
}

@media (min-width: 1024px) {

  .nQXDhC5wLyKGzK8ChiOa .DlCfVbm11Uy_d0GuwdYA {
    font-size: 24px;
    line-height: 2.25rem;
  }
}

.nQXDhC5wLyKGzK8ChiOa .T8O0SRaaXJvCpUfkqMhy {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  -moz-column-gap: 1rem;
       column-gap: 1rem;
  row-gap: 0.25rem;
  font-size: 0.875rem;
  line-height: 1.5rem;
}

@media (min-width: 1024px) {

  .nQXDhC5wLyKGzK8ChiOa .T8O0SRaaXJvCpUfkqMhy {
    -moz-column-gap: 1.5rem;
         column-gap: 1.5rem;
    font-size: 20px;
    line-height: 2.25rem;
  }
}

.qFmySP54VOtfZwF7hcvw {
  overflow-wrap: anywhere;
  white-space: normal;
}

.y6kXY5GlBIRJw3gJAiHO {
  display: block;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 400;
}

.nMMer2jRXpqkYSNKqLsm {
  display: block;
}
`, "",{"version":3,"sources":["webpack://./src/pages/PledgeConsentApproval/components/CustomerDetails/CustomerDetails.module.css"],"names":[],"mappings":"AACE;EAAA,uBAAsE;EAAtE,iBAAsE;EAAtE,sBAAsE;EAAtE,2DAAsE;EAAtE,kBAAsE;EAAtE,4DAAsE;EAAtE,gBAAsE;EAAtE;AAAsE;;AAItE;EAAA,qBAAkD;EAAlD,eAAkD;EAAlD,gBAAkD;EAAlD;AAAkD;;AAIlD;EAAA,qBAAoD;EAApD,eAAoD;EAApD,gBAAoD;EAApD;AAAoD;;AAIpD;EAAA,eAA6C;EAA7C,gBAA6C;EAA7C;AAA6C;;AAI7C;EAAA;AAAW;;AAIX;EAAA,aAA6E;EAA7E,eAA6E;EAA7E,mBAA6E;EAA7E,uBAA6E;OAA7E,kBAA6E;EAA7E,gBAA6E;EAA7E,eAA6E;EAA7E;AAA6E;;AAI7E;EAAA,aAAiB;EAAjB;AAAiB;;AAIjB;EAAA;AAAkB;;AAIlB;EAAA;AAAoB;;AAGtB,0BAA0B;AAExB;EAAA;AAAiB;AAAjB;;EAAA;IAAA;EAAiB;AAAA;;AAIjB;EAAA,qBAAuE;EAAvE,eAAuE;EAAvE,gBAAuE;EAAvE;AAAuE;;AAAvE;;EAAA;IAAA,eAAuE;IAAvE;EAAuE;AAAA;;AAIvE;EAAA,qBAAwE;EAAxE,iBAAwE;EAAxE,gBAAwE;EAAxE;AAAwE;;AAAxE;;EAAA;IAAA,eAAwE;IAAxE;EAAwE;AAAA;;AAIxE;EAAA,eAAkE;EAAlE,gBAAkE;EAAlE;AAAkE;;AAAlE;;EAAA;IAAA,eAAkE;IAAlE;EAAkE;AAAA;;AAIlE;EAAA,aAA2G;EAA3G,eAA2G;EAA3G,mBAA2G;EAA3G,qBAA2G;OAA3G,gBAA2G;EAA3G,gBAA2G;EAA3G,mBAA2G;EAA3G;AAA2G;;AAA3G;;EAAA;IAAA,uBAA2G;SAA3G,kBAA2G;IAA3G,eAA2G;IAA3G;EAA2G;AAAA;;AAG7G;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAGE;EAAA,cAAgC;EAAhC,mBAAgC;EAAhC,oBAAgC;EAAhC;AAAgC;;AAIhC;EAAA;AAAY","sourcesContent":[".customerDetails {\n  @apply border-2 border-info-400 bg-lightBlue rounded-md p-5 font-inter;\n}\n\n.idNumber {\n  @apply mb-2 text-[14px] font-normal leading-[20px];\n}\n\n.customerName {\n  @apply mb-2 text-[18px] font-semibold leading-[24px];\n}\n\n.address {\n  @apply text-[16px] font-normal leading-[24px];\n}\n\n.addressText {\n  @apply mb-0;\n}\n\n.additionalDetails {\n  @apply flex flex-wrap items-center gap-x-6 gap-y-1 text-[16px] leading-[24px];\n}\n\n.detailItem {\n  @apply flex gap-1;\n}\n\n.detailLabel {\n  @apply font-normal;\n}\n\n.detailValue {\n  @apply font-semibold;\n}\n\n/* Customer Consent page */\n.customerConsent {\n  @apply p-4 lg:p-5;\n}\n\n.customerConsent .idNumber {\n  @apply mb-2 text-base lg:text-[24px] font-normal leading-6 lg:leading-8;\n}\n\n.customerConsent .customerName {\n  @apply mb-2 text-2xl lg:text-[36px] font-semibold leading-7 lg:leading-8;\n}\n\n.customerConsent .address {\n  @apply text-base lg:text-[24px] font-normal leading-6 lg:leading-9;\n}\n\n.customerConsent .additionalDetails {\n  @apply flex flex-wrap items-center gap-x-4 lg:gap-x-6 gap-y-1 text-sm lg:text-[20px] leading-6 lg:leading-9;\n}\n\n.customerName {\n  overflow-wrap: anywhere;\n  white-space: normal;\n}\n\n.wakilLabel {\n  @apply block text-sm font-normal;\n}\n\n.ownerName {\n  @apply block;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"customerDetails": `qit8ctL5PoTnJFWiXp3B`,
	"idNumber": `_qDbpGmEToW6RwSmt2Zh`,
	"customerName": `qFmySP54VOtfZwF7hcvw`,
	"address": `DlCfVbm11Uy_d0GuwdYA`,
	"addressText": `ZZYvQ3qNFZ8pXzynxNMz`,
	"additionalDetails": `T8O0SRaaXJvCpUfkqMhy`,
	"detailItem": `UcxNEx0wq5CELbxxmwqu`,
	"detailLabel": `e7sPgtSArdcSWbxe6CgJ`,
	"detailValue": `QXGHtLmEWNDb7rWXRMAu`,
	"customerConsent": `nQXDhC5wLyKGzK8ChiOa`,
	"wakilLabel": `y6kXY5GlBIRJw3gJAiHO`,
	"ownerName": `nMMer2jRXpqkYSNKqLsm`
};
export default ___CSS_LOADER_EXPORT___;
